import yogurt from '../assets/images/yogurtMeal.webp';
import beef from '../assets/images/beefMeal.webp';
import toast from '../assets/images/toastMeal.webp';
import tortilla from '../assets/images/tortillaMeal.webp';
import pancakes from '../assets/images/pancakesMeal.webp';
import tako from '../assets/images/tako.webp';
import humus from '../assets/images/humus.webp';
import dinner64 from '../assets/images/dinner64.webp';

import breakfast9 from '../assets/images/breakfast9.webp';
import breakfast6 from '../assets/images/breakfast6.webp';
import breakfast4 from '../assets/images/breakfast4.webp';
import breakfast7 from '../assets/images/breakfast7.webp';
import breakfast10 from '../assets/images/breakfast10.webp';
import breakfast12 from '../assets/images/breakfast12.webp';

import lunch43 from '../assets/images/lunch43.webp';
import lunch45 from '../assets/images/lunch45.webp';
import lunch50 from '../assets/images/lunch50.webp';
import lunch51 from '../assets/images/lunch51.webp';
import lunch54 from '../assets/images/lunch54.webp';
import lunch57 from '../assets/images/lunch57.webp';

import dinner73 from '../assets/images/dinner73.webp';
import dinner76 from '../assets/images/dinner76.webp';
import dinner80 from '../assets/images/dinner80.webp';
import dinner83 from '../assets/images/dinner83.webp';
import dinner81 from '../assets/images/dinner81.webp';

import snack24 from '../assets/images/snack24.webp';
import snack25 from '../assets/images/snack25.webp';
import snack27 from '../assets/images/snack27.webp';
import snack37 from '../assets/images/snack37.webp';
import snack36 from '../assets/images/snack36.webp';
import snack35 from '../assets/images/snack35.webp';

import dietImg from '../assets/images/dietPicture.png';
import vineImg from '../assets/images/vinePicture.png';
import pizza from '../assets/images/pizzaMeal.png';

import calorieFree from '../assets/images/calorieFreeTransition.png';
import metabolismType from '../assets/images/promise.png';

import self from '../assets/images/self-awareness-start.webp';
import bodySpeaks from '../assets/images/body-speaks.webp';
import motivHeart from '../assets/images/motivation-heart.webp';
import metabolismType2 from '../assets/images/image-body.png';

import dnaReviewMaria from '../assets/images/card-dna-01.png';
import dnaReviewDaniel from '../assets/images/card-dna-02.png';
import dnaReviewSophie from '../assets/images/card-dna-03.png';

import metabolism from '../assets/images/cardPlanMetabolism.png';
import dna from '../assets/images/dna.png';

import metabolismImpact from '../assets/images/metabolism-impact.png';
import progressUnlocked from '../assets/images/progress-unlocked.png';
import elite from '../assets/images/elite-insight-access.png';

import upsaleBundle from '../assets/images/upsale-nutrition-bundle.png';
import upsaleEthnicity from '../assets/images/upsale-ethnicity.png';
import upsaleDna from '../assets/images/upsaleDna.png';

import metabolismAnalysis from '../assets/images/metabolism-analysis.png';
import ethnicityNutrition from '../assets/images/ethnicity-nutrition-promise.png';
import faceScanAnimationPoster from '../assets/images/face-scan-animation-poster.png';
import dnaMap from '../assets/images/dna-map.jpeg';
import dnaFace from '../assets/images/dna-face.jpeg';

export const images = {
  yogurt,
  beef,
  toast,
  tortilla,
  pancakes,
  tako,
  humus,
  dinner64,
  breakfast9,
  breakfast6,
  breakfast4,
  breakfast7,
  breakfast10,
  breakfast12,
  lunch43,
  lunch45,
  lunch50,
  lunch51,
  lunch54,
  lunch57,
  dinner73,
  dinner76,
  dinner80,
  dinner83,
  dinner81,
  snack24,
  snack25,
  snack27,
  snack37,
  snack36,
  snack35,
  dietImg,
  vineImg,
  pizza,
  calorieFree,
  metabolismType,
  self,
  bodySpeaks,
  motivHeart,
  metabolismType2,
  dnaReviewMaria,
  dnaReviewDaniel,
  dnaReviewSophie,
  metabolism,
  dna,
  metabolismImpact,
  progressUnlocked,
  elite,
  upsaleBundle,
  upsaleEthnicity,
  metabolismAnalysis,
  ethnicityNutrition,
  upsaleDna,
  faceScanAnimationPoster,
  dnaMap,
  dnaFace,
};

export const allImages = Object.values(images);
